import React, { forwardRef, useImperativeHandle } from "react";
import { MDBDataTableV5 } from "mdbreact";

const DataTableSubscriptions = forwardRef((props, ref) => {
	let data = props.data;

	let finalData = [];

	
	useImperativeHandle(ref, () => ({
		deSelectAll(){
			//count = deselectAllCheckboxes(document);
			// setinputCheckedCount(count);
			// props.countRows(count);
		}

	}));

	if (data) {
		for (var index = 0; index < data.length; index++) {
			let rowItem = {};
			rowItem["id"] = data[index].id;
			rowItem["name"] = data[index].name;
			rowItem["price"] = data[index].price;
			rowItem["discounted_price"] = data[index].discounted_price;
			rowItem["projects_limit"] = data[index].projects_limit;
			rowItem["members_limit"] = data[index].members_limit;
			rowItem["partners_limit"] = data[index].partners_limit;
			rowItem["disk_space"] = data[index].disk_space;
			rowItem["status"] = data[index].status;
			rowItem["statusButton"] = <button className={`${data[index]?.status ? 'btn btn-primary' : 'btn btn-danger'}`} onClick={() => props.changeStatus(rowItem)}> {data[index]?.status ? <i className='fa fa-unlock'></i> : <i className='fa fa-lock'></i> }</button>;
			rowItem["mode"] = "edit";
			rowItem["editButton"] = <button className="btn custom-btn-outline-info" onClick={() => props.openModal(rowItem)}><i className='fa fa-edit'></i></button>;
		    
		finalData.push(rowItem);
		}
		console.log("final data", finalData);
	}
	
//const [datatable, setDatatable] = React.useState({
const datatable = {  
  columns: [
      {
        label: 'Name',
        field: 'name',
        sort: 'asc',
        width: 150
      },
	  {
        label: 'Price',
        field: 'price',
        sort: 'asc',
        width: 50
      },
      {
        label: 'Discounted Price',
        field: 'discounted_price',
        sort: 'asc',
        width: 100
      },
      {
        label: 'Projects Limit',
        field: 'projects_limit',
        sort: 'asc',
        width: 100
      },
      {
        label: 'Members Limit',
        field: 'members_limit',
        sort: 'asc',
        width: 100
      },
      {
        label: 'Partners Limit',
        field: 'partners_limit',
        sort: 'asc',
        width: 100
      },
      {
        label: 'Disk Space',
        field: 'disk_space',
        sort: 'asc',
        width: 100
      },
      {
        label: 'Stutus',
        field: 'statusButton',
        sort: 'asc',
        width: 50
      },
	    {
        label: 'Actions',
        field: 'editButton',
        width: 150,
		    sort: 'disabled'
      } 
    ],
    rows: finalData 
	};
  return (
    <MDBDataTableV5 
		hover
		id="mdbDtTable"
		entries={10}
    data={datatable}
   	striped
		bordered
		small
		searchTop
		sortable={false}
		searchBottom={false}

    />
	
	
	

	
  );
});

export default DataTableSubscriptions;